import { render, staticRenderFns } from "./main-layout.vue?vue&type=template&id=3e8d5879&scoped=true"
import script from "./main-layout.vue?vue&type=script&lang=js"
export * from "./main-layout.vue?vue&type=script&lang=js"
import style0 from "./main-layout.vue?vue&type=style&index=0&id=3e8d5879&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8d5879",
  null
  
)

export default component.exports